
const DACH_Countries: any = [
    { countryID: 3, countryName: 'Germany' },
    { countryID: 15, countryName: 'Austria' },
    { countryID: 219, countryName: 'Switzerland' },
];

export { DACH_Countries };
